import Vue from 'vue'
import App from './App.vue'
import StringManager from './plugins/strings'
import store from './store'

Vue.config.productionTip = false

Vue.use(StringManager)

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
